import { Injectable } from '@angular/core';
import { StateService } from '../../../shared/state/state.service';
import { SidebarService } from '../../../shared/sidebar/sidebar.service';
import { Point } from 'geojson';
import { MapElement } from '../../../shared/map/map-element.model';
import { MapService, MarkerGeometry } from '../../../shared/map/map.service';
import { Layer } from '../../../shared/map/layer/layer.model';
import { TabId } from '../../../custom/vrgroup/train-info/train-info/train-info.component';

@Injectable({
  providedIn: 'root'
})
export class InfoActionService {
  constructor(
    private stateService: StateService,
    private sidebarService: SidebarService
  ) {

  }

  public openDetails(layer: Layer, feature: MapElement<MarkerGeometry>, openTab: TabId = 'schedule') {
    const panel = 'ElementInfo' + this.getId(layer, feature);
    this.stateService.updateState(panel, feature.id);
    this.sidebarService.requestSidebarPanel(panel, { feature, openTab });
  }

  private getId(layer: Layer, feature: MapElement<MarkerGeometry>) {
    try {
      return feature.properties[layer.metadata.uniqueBy];
    } catch (error) {
      return '';
    }
  }
}
